import { render, staticRenderFns } from "./cust_header_component.vue?vue&type=template&id=87b67e84&scoped=true&"
import script from "./cust_header_component.vue?vue&type=script&lang=js&"
export * from "./cust_header_component.vue?vue&type=script&lang=js&"
import style0 from "./cust_header_component.vue?vue&type=style&index=0&id=87b67e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b67e84",
  null
  
)

export default component.exports